/* section-footer-delfino.js — scena marină din subsol (Task 40).

   Clipul de fundal e pur decorativ, deci nu are voie să coste nimic pe o conexiune slabă: <video>
   pleacă din Liquid FĂRĂ `src` (doar data-src / data-src-mobile) și primește sursa abia când scena
   se apropie de ecran (IntersectionObserver cu rootMargin 300px). Dacă vizitatorul a cerut mai
   puțină mișcare, are „economisire de date" pornită sau e pe 2G/3G, sursa nu se pune NICIODATĂ —
   rămâne posterul (sau rezerva CSS), iar filtrul SVG de val se scoate.

   Idempotent (`data-bound`), curățenia prin DL.onDestroy — o rulează theme.js pe
   `shopify:section:unload`, adică la fiecare re-randare din editorul de teme. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';

  function mq(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function connection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  }

  function saveData() {
    var c = connection();
    return !!(c && c.saveData);
  }

  function slowNetwork() {
    var c = connection();
    var type = c && c.effectiveType;
    return type === '2g' || type === 'slow-2g' || type === '3g';
  }

  function bindScene(scene) {
    scene.dataset.bound = '1';

    // Fără mișcare: fără val (filtrul inline iese, rămâne doar blur-ul din CSS) și fără clip.
    var still = mq('(prefers-reduced-motion: reduce)') || saveData();
    if (still) {
      scene.classList.add('dl-fscene--still');
      var below = scene.querySelector('.dl-fword--below');
      if (below && below.style) below.style.removeProperty('filter');
    } else if (mq(MOBILE)) {
      // Pe ecran mic aceeași deplasare ar rupe literele (sunt mult mai mici) — val mai domol.
      var displacement = scene.querySelector('feDisplacementMap');
      if (displacement) displacement.setAttribute('scale', '3');
    }

    var video = scene.querySelector('[data-dl-footer-video]');
    if (!video) return;

    if (still || slowNetwork() || !('IntersectionObserver' in window)) {
      scene.classList.add('dl-fscene--poster-only');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          video.pause();
          return;
        }
        if (!video.getAttribute('src')) {
          var src = (mq(MOBILE) && video.dataset.srcMobile) || video.dataset.src || video.dataset.srcMobile || '';
          if (!src) return;
          video.setAttribute('src', src);
          if (typeof video.load === 'function') video.load();
        }
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () { /* autoplay blocat — rămâne posterul */ });
      });
    }, { rootMargin: '300px 0px' });
    observer.observe(scene);

    if (window.DL && typeof window.DL.onDestroy === 'function') {
      window.DL.onDestroy(scene, function () {
        observer.disconnect();
        video.pause();
        delete scene.dataset.bound;
      });
    }
  }

  /* ── Acordeonul de telefon (Home v2, 21.09) ────────────────────────────────────────────────
     Sub 768px (același prag ca în CSS: 767.98px) fiecare coloană `[data-dl-f2-col]` devine un
     acordeon ÎNCHIS: titlul <h3> primește un <button aria-expanded aria-controls>, iar panoul
     `[data-dl-f2-panel]` devine `role="region"` etichetat de buton. Înălțimea se animă din CSS
     (grid-template-rows 0fr → 1fr), iar conținutul închis e `visibility: hidden`, deci iese și din
     ordinea de Tab, și din cititorul de ecran. Pot sta deschise mai multe deodată.
     De la 768px în sus (și fără JS) markup-ul rămâne cel din Liquid — titlu simplu + listă —
     deci desktopul/tableta nu se schimbă deloc; la trecerea peste prag (rotire, redimensionare)
     butoanele se pun/se scot singure. */
  var ACCORDION = '(max-width: 767.98px)';
  var CHEVRON = '<svg class="dl-f2-chevron" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';

  function setOpen(col, open) {
    var btn = col.querySelector('[data-dl-f2-toggle]');
    if (!btn) return;
    col.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function accordionOn(scene, cols) {
    cols.forEach(function (col) {
      var title = col.querySelector('.dl-f2-col-title');
      var panel = col.querySelector('[data-dl-f2-panel]');
      if (!title || !panel || title.querySelector('[data-dl-f2-toggle]')) return;
      var label = title.textContent;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dl-f2-toggle';
      btn.id = panel.id + '-btn';
      btn.setAttribute('data-dl-f2-toggle', '');
      btn.setAttribute('aria-controls', panel.id);
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="dl-f2-toggle-label"></span>' + CHEVRON;
      btn.firstChild.textContent = label;
      title.textContent = '';
      title.appendChild(btn);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', btn.id);
      col.classList.remove('is-open');
    });
    scene.classList.add('dl-f2--acc');
  }

  function accordionOff(scene, cols) {
    scene.classList.remove('dl-f2--acc');
    cols.forEach(function (col) {
      var title = col.querySelector('.dl-f2-col-title');
      var panel = col.querySelector('[data-dl-f2-panel]');
      var btn = title && title.querySelector('[data-dl-f2-toggle]');
      if (btn) title.textContent = btn.textContent;
      if (panel) {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
      }
      col.classList.remove('is-open');
    });
  }

  function bindAccordion(scene) {
    var cols = Array.prototype.slice.call(scene.querySelectorAll('[data-dl-f2-col]'));
    if (!cols.length || !window.matchMedia) return;
    scene.dataset.accBound = '1';
    var mql = window.matchMedia(ACCORDION);

    function sync() {
      if (mql.matches) accordionOn(scene, cols);
      else accordionOff(scene, cols);
    }
    function onClick(event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-dl-f2-toggle]') : null;
      if (!btn) return;
      var col = btn.closest('[data-dl-f2-col]');
      if (col) setOpen(col, !col.classList.contains('is-open'));
    }
    // Editorul de teme: la selectarea unui bloc-coloană îl deschidem, ca Robert să vadă ce editează.
    function onBlockSelect(event) {
      var col = event.target && event.target.closest ? event.target.closest('[data-dl-f2-col]') : null;
      if (col && mql.matches) setOpen(col, true);
    }

    sync();
    scene.addEventListener('click', onClick);
    scene.addEventListener('shopify:block:select', onBlockSelect);
    if (mql.addEventListener) mql.addEventListener('change', sync);
    else if (mql.addListener) mql.addListener(sync);

    if (window.DL && typeof window.DL.onDestroy === 'function') {
      window.DL.onDestroy(scene, function () {
        scene.removeEventListener('click', onClick);
        scene.removeEventListener('shopify:block:select', onBlockSelect);
        if (mql.removeEventListener) mql.removeEventListener('change', sync);
        else if (mql.removeListener) mql.removeListener(sync);
        accordionOff(scene, cols);
        delete scene.dataset.accBound;
      });
    }
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-dl-footer-scene]:not([data-bound])').forEach(bindScene);
    scope.querySelectorAll('[data-dl-footer-scene]:not([data-acc-bound])').forEach(bindAccordion);
  }

  /* theme.js e încărcat tot cu `defer`, la finalul <body>, DUPĂ scriptul secțiunii: la parse time
     window.DL încă nu există. Un `readyState === 'loading'` ar fi mereu fals aici (scripturile
     defer rulează în „interactive"), deci verificarea corectă e „complete" — cazul fișierului
     injectat după pornirea paginii (editorul de teme), care se înregistrează pe loc. */
  function register() {
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(init);
    else init(document);
  }
  document.readyState === 'complete' ? register() : document.addEventListener('DOMContentLoaded', register);
})();
